import fetchCaveats from '../Services/fetchCaveats';

export default () => async (dispatch) => {

  dispatch(fetchCaveats());

}